import React from 'react';
import { roundInfoStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';

export const MobileRoundId = observer(() => {
  const { roundId } = roundInfoStore;
  return (
    <div className='mob-g-c-ins-id-wr'>
      <p className='mob-g-c-ins-id-left'>id:</p>
      <p className='mob-g-c-ins-id-right'>{roundId}</p>
    </div>
  );
});
